import React, { FC } from 'react';
import { Input } from 'antd';
import { Close, Search } from 'common/svg';

interface IComponentProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

export const SearchInput: FC<IComponentProps> = ({ placeholder, value, onChange }) => {
  return (
    <Input
      className="search-input"
      placeholder={placeholder}
      prefix={<Search className="icon-gray" />}
      allowClear={{ clearIcon: <Close className="icon-gray" /> }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};
